import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { currencyOptionsConstant, serviceConstants } from 'src/app/constants/service.constants';
import { Subject } from 'rxjs';
import { GridApi } from 'ag-grid-community';
import { EditAndDeleteOperationsRenderer } from 'src/app/common/client-grid/edit-and-delete-operations.component';
import { CommonService } from '../../../../services/common.service';
import { UserService } from '../../../../services/user.service';
import { DateObject, Document_Upload_File, SCREEN_CONTROL, SCREEN_RESPONSE, ScreenResponseModel } from '../../../../models/common';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EAPDatashareService } from 'src/app/services/eap/eap-datashare.service';
import { DatePipe } from '@angular/common';
import { FileService } from 'src/app/services/file.service';
import { EapSummaryService } from 'src/app/services/eap/eap-summary.service';
import { EapStudyTeamAddOrRoleComponent } from '../eap-study-team-add-or-role/eap-study-team-add-or-role.component';
import { EapStudyTeamOrganizationViewModalComponent } from '../../eap-study-team-organization/eap-study-team-organization-view-modal/eap-study-team-organization-view-modal.component';
import * as _ from 'lodash';

@Component({
  selector: 'app-eap-study-team-team-view-modal',
  templateUrl: './eap-study-team-team-view-modal.component.html',
  styleUrls: ['./eap-study-team-team-view-modal.component.scss']
})
export class EapStudyTeamTeamViewModalComponent implements OnInit {

  formFields: any;
  titleOptions: any = [];
  columnDefs: any;
  operations: any;
  gridApi: GridApi;
  selectedRow: any;
  rowData: any;
  gridOptions: any;
  loadTeam = false;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  formData: FormData;
  files: any[];
  uploadInput: EventEmitter<any>;
  humanizeBytes: Function;
  dragOver: boolean;
  currencyOptions = currencyOptionsConstant;
  frameworkComponents;
  context;
  ApplicationID: any;
  FilesList: any = [];
  Listfiles: any = [];
  userType: string = "";
  documaent_attach_list: Document_Upload_File[] = [];
  IsMultipermission: string = "yes";
  IsClicked = false;
  RolesList: any = [];
  AttachementIds: string = "";
  permission: string = "";
  IsAdmin: string = "";
  @Input() public Content: any;
  staticformFields: any;
  appStatus: boolean = false;
  Application_Type_ID: string = "";
  ModelData: any = null;
  submittedresponse: SCREEN_RESPONSE[] = [];
  IsFormToched: boolean = false;
  isDateModified: boolean = false;
  Full_Date: DateObject;
  tooltipValue: any;
  genInfoFieldControls: any;
  SCREEN_MODEL: any = null;
  Currency_ID: string = "";

  /**
   * Constructor.
   * @param summaryService Service for eap summary operations.
   * @param modalRef Reference to the active modal dialog.
   * @param modalService Service for modal operations.
   * @param eapDatashareserivse Service for sharing data across eap components.
   * @param commonService Service providing common utility functions.
   * @param userService Service for user operations.
   * @param datepipe Service for date formatting.
   * @param fileService Service for file operations.
   */
  constructor(
    private summaryService: EapSummaryService,
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    private eapDatashareserivse: EAPDatashareService,
    public commonService: CommonService,
    private userService: UserService,
    public datepipe: DatePipe,
    public fileService: FileService
  ) {

  }

  /**
   * Called when the grid is ready to be used.
   * @param params Grid ready event parameters.
   */
  onGridReady(params) {
    this.gridApi = params.api;
    setTimeout(() => {
      this.gridApi.sizeColumnsToFit();
      this.gridApi.startEditingCell(params);
    }, 500);
  }

  /**
   * Initializes the component by setting up subscriptions, permissions, and grid configurations.
   *
   * Subscribes to ApplicationID and Application_Type_ID from the data share service to keep track of
   * the current application state. Retrieves screen configuration controls based on the ApplicationID.
   *
   * Sets up permissions for the page based on user access and initializes grid settings such as column
   * definitions, row data, and grid options. Configures the context and framework components for the grid.
   *
   * Initializes file and user type information for the component. Delays enabling the team load flag
   * to allow asynchronous data fetching. In 'Add' mode, generates a unique ID for the content.
   */
  ngOnInit() {
    this.eapDatashareserivse.ApplicationID
      .subscribe({
        next: x => {
          this.ApplicationID = x;
          this.GetScreenConfigControls('SCR-015');
          if (!this.ApplicationID) {
            this.GetEapGenInfoScreenConfigControls();
          }
        }
      });

    if (this.Application_Type_ID == null || this.Application_Type_ID == undefined || this.Application_Type_ID == "") {
      this.eapDatashareserivse.Application_Type_ID
        .subscribe({
          next: x => {
            this.Application_Type_ID = x;
          }
        });
    }
      if (this.Currency_ID == null || this.Currency_ID == undefined || this.Currency_ID == "") {
      this.eapDatashareserivse.Currency_ID.subscribe(x => {
        this.Currency_ID = x;
      });
    }

    this.permission = "";
    this.appStatus = this.commonService.getEAPStatus();

    if (this.commonService.getPagePermission("EAP02") != null && this.commonService.getPagePermission("EAP02") != undefined) {
      this.permission = this.commonService.getPagePermission("EAP02").toLowerCase();
    }

    this.columnDefs = [
      {
        "headerName": "Organization",
        "field": "MemberOrganizationName",
      },
      {
        "headerName": "User Role",
        "field": "RoleName",
      }
    ]

    this.rowData = [];
    this.gridOptions = {
      pagination: true,
      rowSelection: 'single',
      rowHeight: 32,
      defaultColDef: {
        sortable: true,
        suppressNavigable: true,
        cellClass: 'no-border',
        suppressMovable: true,
        IsRequiredEdit: true
      }
    }

    this.context = { componentParent: this };
    this.frameworkComponents = {
      deleteRenderer: EditAndDeleteOperationsRenderer
    };

    this.files = [];
    this.userType = this.userService.getUserType();

    setTimeout(() => {
      this.loadTeam = true;
    }, 350);

    if (this.Content?.heading === 'Add') { //Add mode
      this.Content.content.id = this.commonService.getUniqueId();
    }
  }

  /**
   * Retrieves the screen configuration controls for the given screen code and stores it in the SCREEN_MODEL property.
   * Sets the static form fields for the component based on the received screen data.
   * If the component is in 'Edit' or 'View' mode, calls getStudyTeamData and GetGridData functions to fetch the relevant data.
   * @param screenCode The screen code to fetch the configuration controls for.
   */
  GetScreenConfigControls(screenCode: string) {
    this.commonService.GetScreenConfigControls(screenCode, this.ApplicationID, this.ApplicationID, (ScreenData) => {
      this.SCREEN_MODEL = ScreenData;
      this.staticformFields = ScreenData["SCREEN_CONTROL"];
      if (this.Content?.heading == "Edit" || this.Content?.heading == "View") {
        if (this.Content?.heading == "View") {
          this.permission = 'view';
        }
        this.getStudyTeamData();
        this.GetGridData();
      }
    });
  }

  /**
   * Retrieves the grid data for the study team based on the provided RecordID and ApplicationID.
   * The retrieved data is then used to set the operations for the grid data.
   * The grid is initially hidden while the data is being fetched and then shown after a 200ms delay.
   */
  GetGridData() {
    const url = `api/EAPStudyTeam/GridDataEdit?RecordID1=${this.Content?.content?.id}&ApplicationID1=${this.ApplicationID}`;
    this.summaryService.getScreenDataForEdit(url)
      .subscribe({
        next: result => {
          this.loadTeam = false;
          this.rowData = this.setOperations(result);
          setTimeout(() => {
            this.loadTeam = true;
          }, 200);
        }
      });
  }

  /**
   * Retrieves the study team data for the given RecordID and ApplicationID.
   * Uses the summaryService to call the API endpoint for fetching screen data for edit,
   * and processes the received data by binding it to the dynamic and static controls.
   */
  getStudyTeamData() {
    this.summaryService.getScreenDataForEdit(
      "api/EAPStudyTeam/Edit?RecordID=" + this.Content?.content?.id + "&ApplicationID=" + this.ApplicationID)
      .subscribe({
        next: result => {
          if (result != null) {
            this.ModelData = result;
            //this.permission = result["PERMISSION"];
            this.BindDataToDynamicControls();
            this.BindDataToStaticControls(result);
          }
        }
      });
  }

  /**
   * Bind the data to the dynamic controls based on the current heading.
   *
   * This function will fetch the submitted response for the given application
   * id and row id, and bind the data to the dynamic controls.
   */
  BindDataToDynamicControls() {
    if (this.ApplicationID != null && this.ApplicationID != undefined && this.ApplicationID != "") {
      let sr = new ScreenResponseModel();
      sr.Id = "SCR-015"; // EAP Study Team - Screen/Feature Code
      sr.RowId = this.Content?.content?.id;
      sr.AppId = this.ApplicationID;

      this.summaryService.getEAPScreenResponse(sr)
        .subscribe({
          next: summary => {
            this.submittedresponse = summary;
            if (this.submittedresponse != null && this.submittedresponse.length > 0) {
              for (let i = 0; i < this.staticformFields?.length; i++) {
                let response = this.submittedresponse.filter(x => x.SCREEN_CONTROL_ID == this.staticformFields[i].ID);

                if (response != null && response.length > 0) {
                  if (this.staticformFields[i].CONTROL == '6') {
                    if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                      this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                      let options = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(",");

                      if (this.staticformFields[i].SourceItems != null && this.staticformFields[i].SourceItems != undefined) {
                        for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
                          if (options.indexOf(this.staticformFields[i].SourceItems[c].value) > -1) {
                            this.staticformFields[i].SourceItems[c].Checked = true;
                          }
                          else {
                            this.staticformFields[i].SourceItems[c].Checked = false;
                          }
                        }
                      }
                    }
                  }
                  else if (this.staticformFields[i].CONTROL == '10') {
                    this.staticformFields[i].NotimesChanged = 0;

                    if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                      this.staticformFields[i].ControlValue = [];

                      let options1 = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(',');
                      options1.forEach((item) => {
                        this.staticformFields[i].ControlValue.push(item);
                      });
                      this.staticformFields[i].SUBFIELDNAME = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                    }
                    else {
                      this.staticformFields[i].ControlValue = [];
                    }
                  }
                  else if (this.staticformFields[i].CONTROL == '5') {
                    if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null
                      && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != ""
                      && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined) {
                      let formd = new Date(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                      this.staticformFields[i].ControlValue = formd;

                      if (this.staticformFields[i].DATEFORMATE == 'DD-MMM-YYYY') {
                        let formd = this.commonService.getdisplayedDate(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                        this.staticformFields[i].ControlValue = formd;
                      }
                    }
                  }
                  else {
                    this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                  }

                  this.staticformFields[i].UploadFiles = response[0].UploadFiles;

                  if (this.staticformFields[i].CONTROL == '4') {
                    this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i], "N");
                  }
                }
              }
            }
          }
        });
    }
  }

  /**
   * Bind the static controls to the given MainObjData
   * @param MainObjData - The object data to be bound to the static controls
   */
  BindDataToStaticControls(MainObjData: any): any {
    for (let i = 0; i < this.staticformFields?.length; i++) {
      switch (this.staticformFields[i].FIELD_CODE) {
        case "TITLE":
          this.staticformFields[i].ControlValue = MainObjData.Modal.TITLE;
          break;
        case "FIRST_NAME":
          this.staticformFields[i].ControlValue = MainObjData.Modal.FIRST_NAME;
          break;
        case "MIDDLE_NAME":
          this.staticformFields[i].ControlValue = MainObjData.Modal.MIDDLE_NAME;
          break;
        case "LAST_NAME":
          this.staticformFields[i].ControlValue = MainObjData.Modal.LAST_NAME;
          break;
        case "LICENSE_NO":
          this.staticformFields[i].ControlValue = MainObjData.Modal.LICENSE_NO;
          break;
        case "OCCUPATION":
          this.staticformFields[i].ControlValue = MainObjData.Modal.OCCUPATION;
          break;
        case "SPECIALIZATION":
          this.staticformFields[i].ControlValue = MainObjData.Modal.SPECIALIZATION;
          break;
        case "ADDRESS":
          this.staticformFields[i].ControlValue = MainObjData.Modal.ADDRESS;
          break;
        case "PHONE":
          this.staticformFields[i].ControlValue = MainObjData.Modal.PHONE;
          break;
        case "EMAIL":
          this.staticformFields[i].ControlValue = MainObjData.Modal.EMAIL;
          break;
        case "StudyTeam_Upload":
          this.staticformFields[i].UploadFiles = MainObjData.Modal.StudyTeam_Upload;
          break;
      }

      if (this.staticformFields[i].CONTROL == '4') {
        this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i], "N");
      }
    }
  }

  /**
   * Applies conditions to the controls based on the event value and updates their display, enable, or hide states.
   *
   * @param $event The event object containing the current value to be evaluated against control conditions.
   * @param question The data model of the question that defines conditions and mapped controls.
   * @param makeNull A flag to indicate whether to clear the dependent controls' values if they are hidden or disabled.
   *
   * This function processes the control conditions of the given question and determines which controls
   * should be displayed, hidden, enabled, or disabled based on the conditions' mapped values.
   * It updates arrays of control IDs to track the controls' states. The function then iterates through
   * static form fields and updates each control's display and enable properties based on the tracked IDs.
   * Controls with a CONTROL value of "4" will trigger an update of their parent-child details.
   */
  ApplyConditions($event, question, makeNull) {
    let value = $event.value;

    if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
      question.Control_Condtions = [];
    }

    let displayControlIDS = [];
    let hideControlIDS = [];
    let enableControlIDS = [];
    let disbledControlIDS = [];

    question.Control_Condtions.forEach((item) => {
      if (item.Mapped_Control_Value == value) {
        item.ConditionsList.forEach((otemCon) => {
          switch (otemCon.Mapped_Condtion) {
            case "1": //display
              if (displayControlIDS.length == 0) {
                displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disCntrIds && disCntrIds.length > 0) {
                  disCntrIds.forEach((id) => {
                    if (!displayControlIDS.includes(id)) {
                      displayControlIDS.push(id);
                    }
                  })
                }
              }

              break;
            case "2": //enabled
              if (enableControlIDS.length == 0) {
                enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (enableCntrIds && enableCntrIds.length > 0) {
                  enableCntrIds.forEach((id) => {
                    if (!enableControlIDS.includes(id)) {
                      enableControlIDS.push(id);
                    }
                  })
                }
              }
              break;
            case "3": //hide
              if (hideControlIDS.length == 0) {
                hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (hideCntrIds && hideCntrIds.length > 0) {
                  hideCntrIds.forEach((id) => {
                    if (!hideControlIDS.includes(id)) {
                      hideControlIDS.push(id);
                    }
                  })
                }
              }

              break;

            case "4": //disabled
              if (disbledControlIDS.length == 0) {
                disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disableCntrIds && disableCntrIds.length > 0) {
                  disableCntrIds.forEach((id) => {
                    if (!disbledControlIDS.includes(id)) {
                      disbledControlIDS.push(id);
                    }
                  })
                }
              }
              break;
          }

        });
      }
    });

    //default
    if (value != "") {
      this.staticformFields.forEach((con) => {

        if (displayControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = true;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (hideControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = false;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (enableControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = true;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (disbledControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = false;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }

      });
    }
    else {
      this.UpdateParentChildDetails(question);
    }

    if (makeNull == "Y") {
      this.staticformFields.forEach((con) => {
        if (con.IS_Dependent_Display == false) {
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "8") {
            con.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            });
          }
          if (con.CONTROL == "6") {
            con.SourceItems.forEach((item) => {
              item.Checked = false;
            });
          }
        }
        if (con.IS_Dependent_Display == true) {

        }
        if (con.IS_Dependent_Enabled == false) {
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "8") {
            con.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            });
          }
          if (con.CONTROL == "6") {
            con.SourceItems.forEach((item) => {
              item.Checked = false;
            });
          }
        }
        if (con.IS_Dependent_Enabled == true) {

        }
      });
    }
  }

  /**
   * Updates the parent-child details of the static form fields based on the question's conditions.
   * The function processes the control conditions of the given question and determines which controls
   * should be displayed, hidden, enabled, or disabled based on the conditions' mapped values.
   * It updates arrays of control IDs to track the controls' states. The function then iterates through
   * static form fields and updates each control's display and enable properties based on the tracked IDs.
   * Controls with a CONTROL value of "4" will trigger an update of their parent-child details.
   * @param question The data model of the question that defines conditions and mapped controls.
   */
  UpdateParentChildDetails(question: any) {
    if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
      question.Control_Condtions = [];
    }
    let displayControlIDS = [];
    let hideControlIDS = [];
    let enableControlIDS = [];
    let disbledControlIDS = [];

    question.Control_Condtions.forEach((item) => {
      item.ConditionsList.forEach((otemCon) => {
        switch (otemCon.Mapped_Condtion) {
          case "1": //display
            if (displayControlIDS.length == 0) {
              displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disCntrIds && disCntrIds.length > 0) {
                disCntrIds.forEach((id) => {
                  if (!displayControlIDS.includes(id)) {
                    displayControlIDS.push(id);
                  }
                })
              }
            }

            break;
          case "2": //enabled
            if (enableControlIDS.length == 0) {
              enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (enableCntrIds && enableCntrIds.length > 0) {
                enableCntrIds.forEach((id) => {
                  if (!enableControlIDS.includes(id)) {
                    enableControlIDS.push(id);
                  }
                })
              }
            }
            break;
          case "3": //hide
            if (hideControlIDS.length == 0) {
              hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (hideCntrIds && hideCntrIds.length > 0) {
                hideCntrIds.forEach((id) => {
                  if (!hideControlIDS.includes(id)) {
                    hideControlIDS.push(id);
                  }
                })
              }
            }
            break;

          case "4": //disabled
            if (disbledControlIDS.length == 0) {
              disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disableCntrIds && disableCntrIds.length > 0) {
                disableCntrIds.forEach((id) => {
                  if (!disbledControlIDS.includes(id)) {
                    disbledControlIDS.push(id);
                  }
                })
              }
            }
            break;
        }
      });
    });

    if (this.staticformFields) {
      this.staticformFields.forEach((con) => {
        if (displayControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = false;
        }
        if (hideControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = true;
        }
        if (enableControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = false;
        }
        if (disbledControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = true;
        }
      });
    }
  }

  /**
   * Opens a modal to add a new row to the study team table.
   *
   * Filters the static form fields to only include fields with codes 'StudyTeam_Org' and 'StudyTeam_UserRole'.
   * Passes the filtered fields, application ID, and content ID to the modal component.
   * On modal close, adds the new row to the table and updates the operations.
   */
  addRow() {
    let modalRef = this.modalService.open(EapStudyTeamAddOrRoleComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md right modal-right',
      animation: true
    });
    let tempstaticformFields = this.staticformFields?.filter(x => x.FIELD_CODE == 'StudyTeam_Org' || x.FIELD_CODE == 'StudyTeam_UserRole');
    modalRef.componentInstance.Content = {
      heading: 'Add',
      content: {
        id: this.Content?.content?.id,
        ApplicationID: this.ApplicationID,
        rowDataRoles: this.rowData,
        staticformFields: tempstaticformFields
      }
    }
    modalRef.result.then(result => {
      this.loadTeam = false;
      this.rowData.push(result);
      this.rowData = this.setOperations(this.rowData);
      setTimeout(() => {
        this.loadTeam = true;
      }, 100);
    });
  }

  /**
   * Downloads a file based on the given ID.
   * @param ID The ID of the file to be downloaded.
   */
  DownloadFile(ID) {
    window.open(serviceConstants.apiURL + "api/EAPFileAttachments/Downloadfile?FileID=" + ID);
  }

  onRowDoubleClicked(event) { }

  /**
   * Closes the modal.
   */
  ClosePopup() {
    this.modalRef.close();
  }

  /**
   * Saves the study team data and updates the operations.
   *
   * Validates the controls. If validation is successful, loops through the static form fields and sets the ANSWER property based on the control type.
   * If the control is a checkbox list, sets ANSWER to a comma-separated string of the selected values.
   * If the control is a file upload, sets ANSWER to null and ControlValue to null.
   * If the control is a date picker, formats the date to 'dd-MMM-yyyy' and sets ANSWER to the formatted date.
   * If the control is any other type, sets ANSWER to the ControlValue.
   * If the heading is 'Add', calls SaveEAP_APP to get the application ID and then calls SaveStudyTeam to save the study team data.
   * If the heading is 'Edit', calls SaveStudyTeam to update the study team data.
   * @returns {void}
   */
  SaveStudyTeam() {
    if (this.validateControls()) {
      if (this.staticformFields != null && this.staticformFields?.length > 0) {
        for (let i = 0; i < this.staticformFields.length; i++) {
          switch (this.staticformFields[i].CONTROL) {
            case 6:
              let seletedItem = "";
              for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
                if (this.staticformFields[i].SourceItems[c].Checked == true) {
                  if (seletedItem == "")
                    seletedItem = this.staticformFields[i].SourceItems[c].value;
                  else
                    seletedItem = seletedItem + "," + this.staticformFields[i].SourceItems[c].value;
                }
              }
              this.staticformFields[i].ANSWER = seletedItem;
              break;
            case 8:
              this.staticformFields[i].UploadedDocuments = [];
              if (this.staticformFields[i].UploadFiles) {
                for (let j = 0; j < this.staticformFields[i].UploadFiles.length; j++) {
                  if (this.staticformFields[i].UploadFiles[j].Status == "Add" || this.staticformFields[i].UploadFiles[j].Status == "Delete") {
                    this.staticformFields[i].UploadedDocuments.push(this.staticformFields[i].UploadFiles[j]);
                  }
                }
                this.staticformFields[i].ANSWER = null;
                this.staticformFields[i].ControlValue = null;
              }
              break;
            case 10:
              let SelectedValues = this.staticformFields[i].ControlValue;
              if (SelectedValues != null && SelectedValues != undefined && SelectedValues.length > 0) {
                this.staticformFields[i].ANSWER = SelectedValues.join(",");
              }
              else {
                this.staticformFields[i].ANSWER = "";
              }
              this.staticformFields[i].SUBFIELDNAME = "";
              //this.staticformFields[i].ControlValue = null;
              break;
            case 5:
              let controlanswer = this.staticformFields[i].ControlValue;
              if (controlanswer != null && controlanswer != "" && controlanswer != undefined) {
                let formd = this.datepipe.transform(new Date(controlanswer), 'dd-MMM-yyyy');
                this.staticformFields[i].ANSWER = formd;
              }
              else {
                this.staticformFields[i].ANSWER = controlanswer;
              }
              break;
            default:
              this.staticformFields[i].ANSWER = this.staticformFields[i].ControlValue;
              break;
          }
        }
        let uploadData = new FormData();

        this.RolesList = [];
        if (this.rowData != null && this.rowData.length > 0) {
          for (let j = 0; j < this.rowData.length; j++) {
            let obj = {
              "MemberOrganizationId": this.rowData[j].MemberOrganizationId, "MemberOrganizationName": this.rowData[j].MemberOrganizationName,
              "RoleId": this.rowData[j].RoleId, "RoleName": this.rowData[j].RoleName
            };
            this.RolesList.push(obj);
          }
        }

        if (this.Content?.heading == "Add") {
          if (!this.ApplicationID) {
            this.commonService.Save_EAP_APP_Record(this.genInfoFieldControls, this.Application_Type_ID,this.Currency_ID)
              .subscribe({
                next: (res) => {
                  if (res.Status === 0) {
                    //uploadData.append("ScreenControlsData", JSON.stringify(this.staticformFields));
                    let FinalControls = _.cloneDeep(this.staticformFields);
                    FinalControls.forEach((item) => {
                      switch (item.CONTROL) {
                        case 10:
                          item.ControlValue = null;
                          break;
                      }
                    });
                    uploadData.append("ScreenControlsData", JSON.stringify(FinalControls));
                    this.ApplicationID = res["TransactionID"];
                    this.eapDatashareserivse.setApplicationID(this.ApplicationID);
                    uploadData.append("Appid", this.ApplicationID);
                    uploadData.append("Application_Type_ID", this.Application_Type_ID);
                    uploadData.append("MemberOrganizationsList", JSON.stringify(this.RolesList));

                    this.summaryService.SaveStudyTeam("api/EAPStudyTeam/Insert", uploadData)
                      .subscribe({
                        next: (result) => {
                          if (result.Status === 0) {
                            this.commonService.SuccessBanner(result.Message);
                            this.commonService.refreshApplicationPage(this.ApplicationID, "eap");
                            this.modalRef.close();
                            this.IsClicked = false;
                          }
                          else {
                            this.commonService.ValidationBanner(result.Message);
                          }
                        }
                      });
                  }
                  else {
                    this.commonService.ValidationBanner(res.Message);
                  }
                }
              });
          }
          else {
            //uploadData.append("ScreenControlsData", JSON.stringify(this.staticformFields));
            let FinalControls = _.cloneDeep(this.staticformFields);
            FinalControls.forEach((item) => {
              switch (item.CONTROL) {
                case 10:
                  item.ControlValue = null;
                  break;
              }
            });
            uploadData.append("ScreenControlsData", JSON.stringify(FinalControls));
            uploadData.append("Appid", this.ApplicationID);
            uploadData.append("Application_Type_ID", this.Application_Type_ID);
            uploadData.append("MemberOrganizationsList", JSON.stringify(this.RolesList));

            this.summaryService.SaveStudyTeam("api/EAPStudyTeam/Insert", uploadData)
              .subscribe({
                next: (result) => {
                  if (result.Status === 0) {
                    this.commonService.SuccessBanner(result.Message);
                    this.modalRef.close();
                    this.Content.heading = "Edit";
                    this.IsClicked = false;
                  }
                  else {
                    this.commonService.ValidationBanner(result.Message);
                  }
                }
              });
          }
        }
        else {
          //uploadData.append("ScreenControlsData", JSON.stringify(this.staticformFields));
          let FinalControls = _.cloneDeep(this.staticformFields);
          FinalControls.forEach((item) => {
            switch (item.CONTROL) {
              case 10:
                item.ControlValue = null;
                break;
            }
          });
          uploadData.append("ScreenControlsData", JSON.stringify(FinalControls));
          uploadData.append("Appid", this.ApplicationID);
          uploadData.append("ID", this.Content?.content?.id);
          uploadData.append("SavedAttachements", this.AttachementIds);
          uploadData.append("DeletedFiles", this.Listfiles);
          uploadData.append("MemberOrganizationsList", JSON.stringify(this.RolesList));
          let inactiveValueControls = this.commonService.checkInactiveRecordState(this.staticformFields);

          if (!inactiveValueControls || inactiveValueControls.length == 0) {
            this.summaryService.SaveStudyTeam("api/EAPStudyTeam/Update", uploadData)
              .subscribe({
                next: result => {
                  if (result.Status === 0) {
                    if (result.ErrorCode === "NOCHANGES") {
                      this.getStudyTeamData();
                      this.commonService.ValidationBanner(result.Message);
                    }
                    else {
                      this.commonService.SuccessBanner(result.Message);
                      this.modalRef.close();
                      this.Content.heading = "Edit";
                    }
                    this.IsClicked = false;
                  }
                  else {
                    this.getStudyTeamData();
                    this.commonService.ValidationBanner(result.Message);
                  }
                }
              });
          }
          else {
            let dataMsg = inactiveValueControls.join("</br>");
            this.commonService.ValidationBanner(dataMsg);
          }
        }
      }
    }
  }

  /**
   * Checks if the given file is referenced in any review,
   * if yes, display a validation banner with the message received from the API,
   * if not, adds the file id to the list of deleted files and removes the file from the list of saved files.
   * @param item id of the file to be deleted
   */
  DeleteSavedUpload(item): void {
    this.commonService.CheckIsFileIsRefereancedInReviw(item)
      .subscribe({
        next: (x) => {
          if (x["Status"] == 2 && x["Data"] == false) {
            this.commonService.ValidationBanner(x["Message"]);
          }
          else {
            let code = item;
            this.FilesList.forEach(sec => {
              if (sec.ID === code) {
                if (this.AttachementIds != null && this.AttachementIds != "" && this.AttachementIds != null)
                  this.AttachementIds += "," + sec.ID + ",";
                else
                  this.AttachementIds = sec.ID;
                let isExist = this.FilesList.findIndex((r: any) => r.ID === code);
                if (isExist != -1) {
                  this.FilesList.splice(isExist, 1);
                }
              }
            });
          }
        }
      });
  }

  /**
   * Uploads all the files in the file list to the server for the given EAP Study Team id.
   * @param id The EAP Study Team id for which the files are to be uploaded
   */
  SaveUploadAttachment(id): void {

    let Url = serviceConstants.apiURL + "api/EAPStudyTeam/UploadFiles?TransactionID=" + id;
    const event: any = {
      type: 'uploadAll',
      url: Url,
      method: 'POST',
      data: { Id: "" },
    };

    this.uploadInput.emit(event);
    this.files = [];
  }

  /**
   * Opens a modal to add a new study team team member's organization.
   * The modal is configured with an empty organization object and the current EAP application ID.
   * It is displayed as a large modal positioned on the right side.
   * The modal is configured to be a large (lg) modal with a right (modal-right) class.
   * The modal is also configured to be closed by pressing the escape key or by clicking outside of the modal.
   * The modal is also configured to have animation.
   */
  addNewOrg() {
    let modalRef = this.modalService.open(EapStudyTeamOrganizationViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Add',
      content: {
        id: this['self']?.Content?.content?.id,
        ApplicationID: this.ApplicationID
      }
    }
  }

  /**
   * Validates the input character on key press for the phone number field.
   * Prevents the user from entering any characters other than digits, +, -, and space.
   * @param event The key press event.
   */
  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
      event.value = '';
    }
  }

  /**
   * Validates the controls in the static form fields and updates their styles and validation messages.
   * Iterates over the static form fields, checking if each field is mandatory, enabled, and displayed.
   * Depending on the control type, verifies that the field has a valid value. If a field's value is invalid,
   * it updates the field's style to indicate an error and appends an appropriate validation message.
   *
   * The function also handles specific control types that require additional logic, such as aggregating
   * selected items or checking upload files. If any field is invalid, displays a validation banner with
   * all accumulated messages.
   *
   * @returns {boolean} - Returns true if all controls are valid; otherwise, false.
   */
  validateControls(): boolean {
    let isValid = true;
    let message = "";
    if (this.staticformFields) {
      this.staticformFields.forEach((item) => {
        if (item.IS_MANDATORY && item.IS_Dependent_Enabled == true && item.IS_Dependent_Display == true && item.FIELD_CODE != 'StudyTeam_UserRole' && item.FIELD_CODE != 'StudyTeam_Org') {
          switch (item.CONTROL) {
            case 1:
              if (!item.ControlValue) {
                document.getElementById("dynmcId" + item["ID"]).classList.add(...["ng-touched", "ng-invalid", "validate-error"]);
                document.getElementById("dynmcId" + item["ID"]).classList.remove(...["ng-untouched", "ng-valid"]);
                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }
              else {
                if (item.FIELD_CODE == 'EMAIL') {
                  if (this.commonService.validateEmail(item.ControlValue)) {
                    document.getElementById("dynmcId" + item["ID"]).classList.add(...["ng-untouched", "ng-valid"]);
                    document.getElementById("dynmcId" + item["ID"]).classList.remove(...["ng-touched", "ng-invalid", "validate-error"]);

                  }
                  else {
                    document.getElementById("dynmcId" + item["ID"]).classList.add(...["ng-touched", "ng-invalid", "validate-error"]);
                    document.getElementById("dynmcId" + item["ID"]).classList.remove(...["ng-untouched", "ng-valid"]);
                    message += `Please enter valid ${item.LABEL} <br/>`;
                    isValid = false;
                  }
                }
              }
              break;
            case 2:
            case 3:
            case 5:
            case 4:
            case 11:
              if (!item.ControlValue) {
                if (item.FIELD_CODE != 'StudyTeam_UserRole') {
                  document.getElementById("dynmcId" + item["ID"]).classList.add(...["ng-touched", "ng-invalid", "validate-error"]);
                  document.getElementById("dynmcId" + item["ID"]).classList.remove(...["ng-untouched", "ng-valid"]);
                  message += `Please enter ${item.LABEL} <br/>`;
                  isValid = false;
                }
              }
              break;
            case 10:

              if (!(item.ControlValue) || (item.ControlValue != null && item.ControlValue.length == 0)) {
                document.getElementById("dynmcId" + item["ID"]).classList.add(...["ng-touched", "ng-invalid", "validate-error"]);
                document.getElementById("dynmcId" + item["ID"]).classList.remove(...["ng-untouched", "ng-valid"]);

                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }


              break;
            case 6:
              let seletedItem = "";
              for (let c = 0; c < item.SourceItems.length; c++) {
                if (item.SourceItems[c].Checked == true) {
                  if (seletedItem == "")
                    seletedItem = item.SourceItems[c].value;
                  else
                    seletedItem = seletedItem + "," + item.SourceItems[c].value;
                }
              }
              item.ControlValue = seletedItem;
              if (!item.ControlValue) {
                document.getElementById("dynmcId" + item["ID"]).classList.add(...["ng-touched", "ng-invalid", "validate-error"]);
                document.getElementById("dynmcId" + item["ID"]).classList.remove(...["ng-untouched", "ng-valid"]);

                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }
              break;
            case 7:
              if (!item.ControlValue) {
                document.getElementById("dynmcId" + item["ID"]).classList.add(...["ng-touched", "ng-invalid", "validate-error"]);
                document.getElementById("dynmcId" + item["ID"]).classList.remove(...["ng-untouched", "ng-valid"]);

                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }
              break;
            case 8:
              if (item.UploadFiles != null && item.UploadFiles != undefined && item.UploadFiles.length == 0) {
                document.getElementById("dynmcId" + item["ID"]).classList.add(...["ng-touched", "ng-invalid", "validate-error"]);
                document.getElementById("dynmcId" + item["ID"]).classList.remove(...["ng-untouched", "ng-valid"]);

                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }
              break;
            case 9:
              break;
          }
        }
        else {
          switch (item.CONTROL) {
            case 1:
              if (item.ControlValue) {
                if (item.FIELD_CODE == 'EMAIL') {
                  if (this.commonService.validateEmail(item.ControlValue)) {
                    document.getElementById("dynmcId" + item["ID"]).classList.add(...["ng-untouched", "ng-valid"]);
                    document.getElementById("dynmcId" + item["ID"]).classList.remove(...["ng-touched", "ng-invalid", "validate-error"]);

                  }
                  else {
                    document.getElementById("dynmcId" + item["ID"]).classList.add(...["ng-touched", "ng-invalid", "validate-error"]);
                    document.getElementById("dynmcId" + item["ID"]).classList.remove(...["ng-untouched", "ng-valid"]);

                    message += `Please enter valid ${item.LABEL} <br/>`;
                    isValid = false;
                  }
                }
              }
              break;
            case 2:
            case 3:
            case 5:
            case 4:
            case 11:
            case 10:
            case 6:
            case 7:
            case 8:
            case 9:
          }
        }
      });
    }

    //Check atleast single field value exists
    if (isValid) {
      isValid = this.commonService.checkHasSingleControlValue(this.staticformFields);
      if (!isValid) {
        message += `Please enter atleast one field. <br/>`;
      }
    }

    if (!isValid)
      this.commonService.ValidationBanner(message);
    return isValid;
  }

  /**
   * Opens a modal to edit a row in the study team table.
   *
   * Filters the static form fields to only include fields with codes 'StudyTeam_Org' and 'StudyTeam_UserRole'.
   * Passes the filtered fields, application ID, and content ID to the modal component.
   * On modal close, updates the row in the table and updates the operations.
   */
  edit() {
    let MemOrgId = this['self'].selectedRow['MemberOrganizationId'];
    let RoleId = this['self'].selectedRow['RoleId'];
    let MemOrgName = this['self'].selectedRow['MemberOrganizationName'];
    let RoleName = this['self'].selectedRow['RoleName'];

    let modalRef = this['self'].modalService.open(EapStudyTeamAddOrRoleComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-sm right modal-right',
      animation: true
    });

    modalRef.componentInstance.Content = {
      heading: 'Edit',
      content: {
        id: this['self']?.Content?.content?.id,
        ApplicationID: this.ApplicationID,
        MemberOrganizationId: MemOrgId, RoleId: RoleId,
        OrganizationName: MemOrgName,
        RoleName: RoleName,
        rowDataRoles: this['self'].rowData
      }
    }

    modalRef.result.then(result => {
      this['self'].loadTeam = false;
      let isOrgExist = this['self'].rowData.findIndex((Role: any) => Role.MemberOrganizationId == result.MemberOrganizationId);
      if (isOrgExist != -1) {
        this['self'].rowData.splice(isOrgExist, 1);
      }
      this['self'].rowData.push(result);
      this['self'].rowData = this['self'].setOperations(this['self'].rowData);
      setTimeout(() => {
        this['self'].loadTeam = true;
      }, 100);
    })

  }

  /**
   * Deletes a study team member from the team.
   *
   * Given the MemOrgId of the selected row, it finds the index of the row in the rowData array and removes it.
   * It then updates the operations by calling the setOperations() method.
   * Finally, it sets the loadTeam variable to false and then back to true after a short delay.
   * @private
   */
  delete() {
    let MemOrgId = this['self'].selectedRow['MemberOrganizationId'];
    let isOrgExist = this['self'].rowData.findIndex((Role: any) => Role.MemberOrganizationId == MemOrgId);
    if (isOrgExist != -1) {
      this['self'].rowData.splice(isOrgExist, 1);
    }
    this['self'].rowData = this['self'].setOperations(this['self'].rowData);
    this['self'].loadTeam = false;
    setTimeout(() => {
      this['self'].loadTeam = true;
    }, 200);
  }

  /**
   * Assigns the provided grid API instance to the component's gridApi property.
   * This allows the component to interact with the grid by accessing its data
   * and controlling its behavior.
   *
   * @param gridApi - The grid API instance to be set for the component.
   */
  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  /**
   * Executes the callback function provided in the operation object.
   * This method is triggered when a callback operation is emitted from the grid,
   * and it calls the callback function with the necessary parameters.
   * @param opr - The operation object containing the callback function and its parameters.
   */
  onCallbackOperation(opr) {
    opr.callback(this.summaryService, this.eapDatashareserivse);
  }

  /**
   * Handles the selection change event emitted by the grid.
   * Updates the selectedRow property with the currently selected row
   * from the grid. If no row is selected, sets selectedRow to null.
   *
   * @param event - The selection changed event emitted by the grid.
   */
  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  /**
   * Takes an array of operations and returns an array of objects.
   * The objects contain the name of the operation, a callback function and a self reference.
   * If the operation id is 'add' or 'view_modal', the object will have an additional property 'disabled' set to false.
   * This method is used to set the operations for the grid.
   * @param parmoperations An array of objects containing the name and id of the operations.
   * @returns An array of objects containing the name, callback, self and disabled (if applicable) properties.
   */
  setDef(parmoperations: any): any {
    this.operations = parmoperations.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal'))
        ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' }
        : { name: operation.name, callback: this[operation.id], self: this }
    });
    return this.operations;
  }

  /**
   * Configures and assigns a set of operations to each element in the provided RawData array.
   * The operations are determined by the user's permission level and the heading of the content.
   * If the permission is "view" or the heading is "View", only a simplified set of operations is assigned.
   * The function modifies each element in RawData by adding an "Operations" property, which contains
   * an array of operation objects. Each operation object includes a name, a callback function,
   * and a reference to the component instance.
   * @param RawData - An array of data elements to which operations will be assigned.
   * @returns The modified RawData array with assigned operations for each element.
   */
  setOperations(RawData: any): any {
    let tempoperations = [
      {
        "name": "Edit",
        "id": "edit"
      },
      {
        "name": "Delete",
        "id": "delete"
      }
    ];

    let tempoperations2 = [];

    RawData.forEach(element => {
      if (this.permission == "view" || this.Content?.heading == 'View') {
        element["Operations"] = this.setDef(tempoperations2);
      }
      else {
        element["Operations"] = this.setDef(tempoperations);
      }
    });

    return RawData;
  }

  /**
   * Returns a comma-separated list of file names from the files array.
   * If the files array is empty or undefined, an empty string is returned.
   * @returns {string} A comma-separated list of file names.
   */
  showFiles() {
    let files = '';

    if (this.files && this.files.length > 0) {
      for (let i = 0; i < this.files.length; i++) {
        files += this.files[i].name;
        if (!(this.files.length - 1 === i)) {
          files += ',';
        }
      }
    }

    return files;
  }

  /**
   * Initiates the upload process for all files.
   * This method constructs an upload event with the necessary details
   * such as the backend endpoint URL, HTTP method, and any additional data.
   * It then emits this event to trigger the upload process.
   * Additionally, it clears the files array to reset the file list before uploading.
   */
  startUpload(): void {
    const event: any = {
      type: 'uploadAll',
      url: 'your-path-to-backend-endpoint',
      method: 'POST',
      data: { foo: 'bar' },
    };

    this.files = [];
    this.uploadInput.emit(event);
  }

  /**
   * Cancels the upload for a file with the given id.
   * This method emits a cancel event with the id of the file to be cancelled.
   * It is invoked when the user clicks the cancel button in the file list.
   * @param {string} id - The id of the file to be cancelled.
   */
  cancelUpload(id: string): void {
    this.uploadInput.emit({ type: 'cancel', id: id });
  }

  /**
   * Handles the output of the uploader component.
   * This method is invoked by the uploader component when there is an output.
   * It handles the different types of output events such as 'allAddedToQueue', 'addedToQueue', 'uploading', 'removed', 'dragOver', 'dragOut', and 'drop'.
   * Based on the type of event, it updates the files array accordingly.
   * It also calls the showFiles() method to update the file list UI.
   * @param {any} output - The output of the uploader component.
   */
  onUploadOutput(output: any | any): void {
    if (output.type === 'allAddedToQueue') {
    } else if (output.type === 'addedToQueue') {
      if (this.files == undefined || this.files == null) {
        this.files = [];
      }
      this.files.push(output.file); // add file to array when added
    } else if (output.type === 'uploading') {
      // update current data in files array for uploading file
      const index = this.files.findIndex(file => file.id === output.file.id);
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      // remove file from array when removed
      this.files = this.files.filter((file: any) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
    } else if (output.type === 'drop') {
      this.dragOver = false;
    }

    this.showFiles();
  }

  /**
   * Handles changes to a single option in the form.
   * It updates the parent and child details of the question and applies any conditions
   * based on the event and question parameters.
   *
   * @param $event - The event object containing the changed value.
   * @param question - The data model of the question whose value was changed.
   */
  singleonChange($event, question) {
    this.UpdateParentChildDetails(question);
    this.ApplyConditions($event, question, "Y");
  }

  /**
   * Updates the `Full_Date` object with the selected date and sets it to the `dynamicDateobj` of the question.
   * Also marks the form as touched and indicates the date has been modified.
   *
   * @param event - The event object containing the selected date.
   * @param question - The data model of the question to update with the selected date.
   */
  DateSelect(event, question) {
    this.IsFormToched = true;
    this.isDateModified = true;
    this.Full_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isDateModified
    }
    question.dynamicDateobj = this.Full_Date;
  }

  /**
   * Preview a file with the given id and name.
   * This method calls the previewFile method of the commonService.
   * @param {string} fileID - The id of the file to preview.
   * @param {string} fileName - The name of the file to preview.
   */
  ViewFile(fileID, fileName) {
    this.commonService.previewFile(fileID, fileName, "med");
  }

  /**
   * Checks if the given filename has an allowed extension.
   * @param {string} Filename - The filename to check.
   * @returns {boolean} True if the extension is allowed, false otherwise.
   */
  isAllowedExtensionFile(Filename) {
    return this.commonService.isAllowedExtension(Filename);
  }

  /**
   * Saves the given selected files to the server as temporary files.
   * It constructs a FormData object and appends the given files to it.
   * It then calls the uploadMultiFiles method of the fileService to upload the files.
   * @param {any} selectedFiles - The files to save to the server as temporary files.
   * @returns {Observable<any>} - The observable returned by the uploadMultiFiles method of the fileService.
   */
  saveTempFiles(selectedFiles: any) {
    const formData = new FormData();
    formData.append(`files`, selectedFiles);
    return this.fileService.uploadMultiFiles(formData, "");
  }

  /**
   * Deletes or marks a file for deletion based on its status.
   *
   * If the file status is "Add", it removes the file from the ques.UploadFiles array.
   * Otherwise, it checks if the file is referenced in any review using the CheckIsFileIsRefereancedInReviw method.
   * If the file is not referenced, it marks the file status as "Delete".
   * Displays a validation banner with a message if the file is referenced.
   *
   * @param {any} file - The file object containing the ID and status.
   * @param {SCREEN_CONTROL} ques - The screen control object containing the list of uploaded files.
   */
  DeleteUpload(file, ques: SCREEN_CONTROL): void {
    this.IsFormToched = true;
    let code = file.ID;
    if (file.Status == "Add") {
      ques.UploadFiles = ques.UploadFiles.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      this.commonService.CheckIsFileIsRefereancedInReviw(code)
        .subscribe({
          next: (x) => {
            if (x["Status"] == 2 && x["Data"] == false) {
              this.commonService.ValidationBanner(x["Message"]);
            }
            else {
              file.Status = "Delete";
            }
          }
        });
    }
  }

  /**
   * Opens the given file for download if the file status is "Edit".
   * @param {Document_Upload_File} item - The file object to open for download.
   */
  OpenFile(item: Document_Upload_File): void {
    if (item.Status == "Edit") {
      window.open(serviceConstants.apiURL + "api/screen/downloadfile/" + item.ID);
    }
  }

  /**
   * Updates the change count and touch status of a question, and sets a tooltip value based on the selected control.
   *
   * Increments the `NotimesChanged` property of the question and marks it as touched. If the question has been
   * changed twice or more, sets the component's `IsFormToched` property to true.
   *
   * After a delay, retrieves the `ControlValue` of the question and checks if it is defined and non-empty.
   * If valid, filters the `SourceItems` to find items whose values are included in the `ControlValue`.
   * Constructs a list of labels from these items and joins them into a comma-separated string, which is
   * assigned to the `tooltipValue` property. If the `ControlValue` is invalid, sets `tooltipValue` to an empty string.
   *
   * @param $event - The event object associated with the change.
   * @param question - The data model of the question whose value was changed.
   */
  changeVal($event, question) {
    question.NotimesChanged = question.NotimesChanged + 1;
    question.IsTouched = true;
    if (question.NotimesChanged >= 2)
      this.IsFormToched = true;

    setTimeout(() => {
      let selectedControl = question.ControlValue;

      if (selectedControl != "" && selectedControl != undefined && selectedControl != null) {
        let controlLabel = question.SourceItems.filter((item) => {
          return selectedControl.indexOf(item.value) > -1;
        });

        let labellist = [];

        controlLabel.forEach((item) => {
          labellist.push(item.label);
        });

        this.tooltipValue = labellist.join(",");
      }
      else {
        this.tooltipValue = "";
      }
    }, 200);
  }

  /**
   * Handles the upload change event for a file upload control.
   *
   * Iterates over the uploaded files and checks if the file is an executable (.exe) or if its size is greater than 50MB.
   * If the file is an .exe, sets the `Isexe` flag to true. If the file is over 50MB, sets the `Is5oMB` flag to true.
   * If either flag is true, displays a validation banner with an appropriate message.
   * If neither flag is true, saves the file to the server by calling `saveTempFiles` and subscribing to the result.
   * If the file already exists on the server, displays a validation banner with an appropriate message. If not, adds the
   * file to the `UploadFiles` array of the question.
   */
  uploadchange(event, ques: SCREEN_CONTROL): void {
    let Isexe = false;
    let Is5oMB = false;
    if (ques.UploadFiles == undefined || ques.UploadFiles == null)
      ques.UploadFiles = [];
    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      let file = event.target.files[i].name;
      let ext = file.match(/\.([^\.]+)$/)[1];
      let filesize = event.target.files[i].size;


      if (file != null && (ext == 'exe')) {
        Isexe = true;
      }
      else if (file != null && ((filesize > 52428800))) {
        Is5oMB = true;
      }
      else {
        this.saveTempFiles(event.target.files[i])
          .subscribe({
            next: (result: any) => {
              let uploadFile = new Document_Upload_File();
              uploadFile.ID = result.Data[0].FileID;
              uploadFile.DOCUMENT_NAME = event.target.files[i].name;
              uploadFile.File = null;
              uploadFile.Status = "Add";
              uploadFile.UploadedDate = this.datepipe.transform(new Date().toUTCString(), 'dd-MMM-YYYY');
              let hasValue = ques.UploadFiles.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase() && x.Status != "Delete");
              if (hasValue.length > 0) {
                this.commonService.ValidationBanner("File already exists with " + uploadFile.DOCUMENT_NAME + " Please update the unique file name");
              }
              else if (ques.ISALLOWMULTIPLEFILES) {
                ques.UploadFiles.push(uploadFile);
              } else {
                ques.UploadFiles.forEach((item) => {
                  item.Status = "Delete";
                })
                ques.UploadFiles.push(uploadFile);
              }
            }
          });
      }
    }

    if (Is5oMB && Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details and Accepts maximum file size 50MB");
    }

    else if (Is5oMB) {
      this.commonService.ValidationBanner("Accepts maximum file size 50MB");
    }

    else if (Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details")
    }
  }

  /**
   * Retrieves the screen configuration controls for the given screen code and stores it in the genInfoFieldControls property.
   * @param screenCode The screen code for which the configuration controls need to be fetched.
   */
  GetEapGenInfoScreenConfigControls() {
    this.commonService.GetScreenConfigControls('SCR-014', '', '', (ScreenData) => {
      this.genInfoFieldControls = ScreenData["SCREEN_CONTROL"];
    });
  }
}
